/* global axios */
import ApiClient from './ApiClient';

// Nested under a conversation and singular, like draft messages: there is at most one suggestion
// per turn, so it has no id in the URL.
class CopilotSuggestionAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  #url(conversationId) {
    return `${this.url}/${conversationId}/copilot_suggestion`;
  }

  // 204 means the turn has no suggestion, which is the common case and not an error.
  get(conversationId) {
    return axios.get(this.#url(conversationId));
  }

  // 202: the generation is async and arrives over the websocket. A refusal comes back 422 with a
  // reason the card shows verbatim -- the agent needs to know it was refused, not just that
  // nothing happened.
  request(conversationId) {
    return axios.post(this.#url(conversationId));
  }

  recordOutcome(conversationId, outcome, suggestionId) {
    return axios.patch(this.#url(conversationId), {
      outcome,
      suggestion_id: suggestionId,
    });
  }
}

export default new CopilotSuggestionAPI();
